import type { CheckoutResponse } from '../services/api'
import type { ShopItem } from '../types'

/** A resumed cart can predate today's personalized catalog. Prefer its server quote. */
export function itemFromCheckout(item: ShopItem, checkout: CheckoutResponse): ShopItem {
    const result = { ...item, cartId: checkout.shoppingCartId || item.cartId }
    const receipt = checkout.checkoutReceipt
    if (receipt) {
        result.price = receipt.price
        result.currency = receipt.currency
    }
    // Ultimate's calendar contents are unlocked rewards, not direct cart goods.
    if (item.type === 'ultimate-pass') return result
    if (receipt && ['chips', 'jackpotJoker', 'joker'].includes(receipt.primaryType || '')) {
        result.type = receipt.primaryType!
        result.amount = receipt.primaryAmount
        result.extras = receipt.extras.map(extra => ({ ...extra, meta: {} }))
        result.shopBonus = receipt.shopBonusAmount > 0 ? {
            amount: receipt.shopBonusAmount, percent: checkout.shopBonusPercent ?? 0,
            title: receipt.shopBonusTitle || item.shopBonus?.title || '',
        } : undefined
        return result
    }
    const reward = checkout.checkoutRewards?.find(reward => reward.type === item.type || (item.type === 'joker' && reward.type === 'jackpotJoker'))
    if (reward) {
        result.amount = reward.amount
        result.shopBonus = reward.shopBonusAmount > 0 ? {
            amount: reward.shopBonusAmount, percent: checkout.shopBonusPercent ?? 0,
            title: item.shopBonus?.title || '',
        } : undefined
    }
    return result
}
